import { Container, Text } from "pixi.js";
import AssetsManager from "../../../core/assets/AssetsManager";
import ControlEvent from "../../../core/control/event/ControlEvent";
import SoundManager from "../../../core/sound/SoundManager";
import LayoutBuilder from "../../../core/utils/LayoutBuilder";
import LayoutElement from "../../../core/view/model/LayoutElement";
import Button from "../../../core/view/ui/Button";
import { UIPanelEvent } from "../../control/event/UIPanelEvent";
import SoundList from "../../sound/SoundList";

export default class PopupPlayerProtectionWarning extends Container {

    private tfMessage: Text;
    private btnContinue: Button;
    private btnExit: Button;

    constructor(private currentTime?: () => { hours: number, minutes: number, seconds: number } | { hours: number, minutes: number, seconds: number }) {
        super();
        LayoutBuilder.create(AssetsManager.layouts.get('PopupPlayerProtectionWarning'), this, (le: LayoutElement) => {
            return this.customClassElementCreate(le);
        });

        this.btnContinue.on('pointerup', this.onBtnContinue, this);
        this.btnExit.on('pointerup', this.onBtnExit, this);

        this.on('added', this.onAdded, this);
        this.on('removed', this.onRemoved, this);
    }

    // PRIVATE API
    protected customClassElementCreate(le: LayoutElement): unknown {
        let instance: unknown = null;

        switch (le.customClass) {
            case 'Button':
                instance = new Button(le);
                break;
        }
        return instance;
    }

    private onAdded() {
        const currentTime = typeof this.currentTime === 'function' ? this.currentTime() : this.currentTime;
        this.tfMessage.text = `${AssetsManager.translations.get('playerProtectionService.warningPopup.tfMessage.tf0')}\n${currentTime.hours} ${AssetsManager.translations.get('playerProtectionService.warningPopup.tfMessage.tf1')} ${currentTime.minutes} ${AssetsManager.translations.get('playerProtectionService.warningPopup.tfMessage.tf2')}\n${AssetsManager.translations.get('playerProtectionService.warningPopup.tfMessage.tf3')}`;
        this.tfMessage.style.align = 'center';
    }

    private onRemoved() {

    }

    private onBtnContinue(): void {
        SoundManager.play(SoundList.UI_BUTTON_CLICK);
        new ControlEvent(UIPanelEvent.HIDE_POPUP).dispatch();
    }

    private onBtnExit(): void {
        SoundManager.play(SoundList.UI_BUTTON_CLICK);
        window.close();
    }
}